#import "../fragments/scheduler-page-config-fragment.graphql"

mutation UpdateSchedulerPageConfig($input: PageConfigUpdateInput!) {
    schedulerPageConfigUpdate(input: $input) {
        pageConfig {
            ...SchedulerPageConfigFragment
            user {
                id
                schedulerRootMeetingsUrl
            }
        }
    }
}
